var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.root},[_c('BaseButton',{attrs:{"size":"large","theme":"yellow"},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.box.data.text)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }